import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";  
import Home from './components/Home/Home';  
import Contact from './components/Contact/Contact';  
import Main from './components/Services/Main';  
import  NavigationBar  from './components/Nav/Nav';
import About from './components/About/About';
import Footer from './components/Footer/Footer';
import Scroll from './components/Scroll/Scroll';
import Founder from './components/founder/Founder'

function App() {
  return (
    <div className="App">
      <Router>
        <Scroll/>
        <NavigationBar className="sticky-top" /> 
        
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path='/about' element={<About/>} />
          <Route path='/services/*' element={<Main/>}/>
          <Route path='/founder' element={<Founder/>}/>
        </Routes>

       <Main/>
       <Footer/>
       </Router>
    </div>
  );
}

export default App;
